import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useAtom } from "jotai";
import { FC, useEffect, useState } from "react";
import { modalQrCodeWhatsApp } from "../../../atoms/atom";
import { EvolutionService } from "../../../services/EvolutionService";

const QrCodeWhatsAppModal: FC = () => {
	const [qrcode, setQrCode] = useState('');
	const [open, setOpen] = useAtom(modalQrCodeWhatsApp);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const load = async () => {
			if (!open) return;
			const response = await new EvolutionService().getQrCode();
			if (response && response.data) {
				setQrCode(response.data.base64);
				setLoading(false);
			}
		};
		load();
	}, [open]);

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			id='modal-qr-code-whatsapp'
		>
			<DialogTitle>Conecte o WhatsApp para configurar</DialogTitle>
			<DialogContent id="modal-qr-code-whatsapp-content">
				{loading
					? <Box
						sx={{display: "flex", justifyContent: "center", height: "400px", alignItems: "center", width: "400px"}}
					>
						<CircularProgress sx={{color: "#48a7dbff"}} size={'50px'}/>
					</Box>
					: <img
						src={qrcode}
						alt="QR Code para configurar"
						style={{
						width: '400px',
						height: '400px',
						display: 'block',
						border: '1px solid #ccc',
						padding: '8px',
						backgroundColor: '#fff'
						}}
					/>
				}
			</DialogContent>
			<DialogActions>
				<Button id="close-form-button" onClick={() => setOpen(false)}>
					Fechar
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default QrCodeWhatsAppModal;